if (!customElements.get("nss-faqs")) customElements.define("nss-faqs", class NSSFaqs extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            categoryBtn: ".js-nss-faqs-category-btn",
            category: ".js-nss-faqs-category",
            categories: ".js-nss-faqs-categories"
        };
        this.category = this.querySelectorAll(this.selectors.category);
        this.categories = this.querySelector(this.selectors.categories);
        this.categoryBtn = this.querySelectorAll(this.selectors.categoryBtn);
        this.init();
    }

    scrollChildToCenter(parent, child) {
        if (parent && child) {
            const parentRect = parent.getBoundingClientRect();
            const childRect = child.getBoundingClientRect();

            const scrollLeft = parent.scrollLeft + (childRect.left - parentRect.left) - (parent.clientWidth / 2) + (child.clientWidth / 2);

            parent.scrollTo({top:0, left: scrollLeft, behavior: 'smooth'});
        }
    }

    init() {
        document.addEventListener('scroll', () => {
            const wHeight = window.innerHeight / 3;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.category.forEach(el => {
                const rec = el.getBoundingClientRect();
                if ((rec.top < wHeight) && (rec.bottom > wHeight)) {
                    const item = this.querySelector(`[href="#${el.getAttribute("id")}"]`);
                    if (item != null) {
                        this.categoryBtn.forEach(btn => {
                            btn.classList.remove("is-active")
                        })
                        item.classList.add("is-active");
                        this.scrollChildToCenter(this.categories?.querySelector('.nss-faqs__category-btns'), item);
                    }
                }
                if ((scrollTop < 100)) {
                    this.categoryBtn.forEach(btn => {
                        btn.classList.remove("is-active")
                    })
                    this.categoryBtn[0]?.classList?.add("is-active")
                    this.scrollChildToCenter(this.categories?.querySelector('.nss-faqs__category-btns'), this.categoryBtn[0]);
                }
            });

            const offsetTop = this.categories?.getBoundingClientRect();
            if (offsetTop.top < 0) {
                this.categories?.classList.add('is-sticky');
            } else {
                this.categories?.classList.remove('is-sticky');
            }


        });
        this.categoryBtn.forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    this.categoryBtn.forEach(item => {
                        item.classList.remove("is-active")
                    });
                    btn.classList?.add("is-active")
                }, 10)
            })
        })
    }
})